import * as React from "react";

import { cn } from "../../lib/utils";

export interface TextareaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  /** Validation error state — red border/ring + aria-invalid. */
  error?: boolean;
}

const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className, error, "aria-invalid": ariaInvalid, ...props }, ref) => {
    return (
      <textarea
        aria-invalid={ariaInvalid ?? (error || undefined)}
        className={cn(
          "flex min-h-[80px] w-full rounded-coronis border border-coronis-gray-200 bg-white px-3 py-2 text-sm text-coronis-navy-600 ring-offset-white placeholder:text-coronis-gray-400 focus-visible:outline-hidden focus-visible:ring-2 focus-visible:ring-coronis-blue-500 focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 dark:border-slate-600 dark:bg-slate-800 dark:text-slate-200 dark:ring-offset-slate-900 dark:placeholder:text-slate-500",
          error && "border-red-500 focus-visible:ring-red-500 dark:border-red-500/70",
          className
        )}
        ref={ref}
        {...props}
      />
    );
  }
);
Textarea.displayName = "Textarea";

export { Textarea };
